import { render, staticRenderFns } from "./ed-tooltip.vue?vue&type=template&id=052afe26&lang=true"
import script from "./ed-tooltip.vue?vue&type=script&lang=js"
export * from "./ed-tooltip.vue?vue&type=script&lang=js"
import style0 from "./ed-tooltip.vue?vue&type=style&index=0&id=052afe26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports